import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 6L9 17L4 12",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheck;
